import { CellRenderType, ComponentTester } from './renderCell.js';

/** Type defined here to render data */

export type IDataCell_Date<T extends 'Raw' | 'Render'> = T extends 'Raw'
  ? number | string | undefined
  : { dataSet: string };

// export type IDataCell_Date = { dataSet: string };

export const getDateTime = (dataSet: string | undefined) => {
  const content = new Date(dataSet ?? '').toLocaleString('en-US', { hour: 'numeric', hour12: true });
  return content.replace(' ', '');
};

export const RenderDate: ComponentTester<CellRenderType.date> = (props) => {
  const content = getDateTime(props.data?.dataSet).toLowerCase();
  return (
    <small data-module-name="cell-date-iso" className="u-block">
      {content}
    </small>
  );
};
